import { gql } from 'graphql-request';

import { ENVIRONMENTS } from 'constants/environments';

const RECOMMENDATION_API_ENDPOINTS = {
  [ENVIRONMENTS.DEVELOPMENT]: 'https://xapi-test.middle-tier-dev.aws.allbirds.com',
  [ENVIRONMENTS.STAGING]: 'https://xapi-test.middle-tier-dev.aws.allbirds.com',
  [ENVIRONMENTS.PRODUCTION]: 'https://xapi.middle-tier-prod.aws.allbirds.com',
};

const API_PATH = '/graphql';
const ENDPOINT_METHOD = 'POST';

// timing out after 5 seconds due to occasional spikes in service response time
const TIMEOUT_MS = 5000;

const CLIENT_SECRET = '2D4Fe114e751428A95bD69aAd2A04AF4';
const CLIENT_NAME = 'Allbirds Web App';

const API_NAME = 'xapi';

const QUERY_GET_CART_RECOMMENDATIONS = gql`
  query getCartRecommendations($cartLineItems: [CartLineItem!]!, $geo: Geo!, $first: Int) {
    getCartRecommendations(cartLineItems: $cartLineItems, geo: $geo, first: $first) {
      name
      cfId
      priority
      recommendedItems {
        cfId
        collectionProductCardImage {
          src
          alt
        }
        colorName
        handle
        image {
          src
          alt
        }
        name
        productId
        productName
        productType
        swatchColors
        swatchImageOverride {
          src
          alt
        }
        sizes {
          isAvailable
          title
          storefrontId
          legacyResourceId
          price
          sku
        }
      }
      priority
      name
    }
  }
`;

export {
  RECOMMENDATION_API_ENDPOINTS,
  API_PATH,
  ENDPOINT_METHOD,
  TIMEOUT_MS,
  CLIENT_SECRET,
  CLIENT_NAME,
  API_NAME,
  QUERY_GET_CART_RECOMMENDATIONS,
};
